import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-delete-drafts-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule],
  template: `
    <mat-dialog-content>
      <span class="body-medium">
        {{ 'orders.ui.seiSicuroDiVolerCancellareSelezionati' | transloco: { value0: (data.count === 1 ? (('orders.ui.1Elemento' | transloco)) : data.count + (" " + ('orders.ui.elementi' | transloco))) } }}
      </span>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton type="button" [mat-dialog-close]="false">{{ 'orders.ui.annulla' | transloco }}</button>
      <button matButton="filled" type="button" [mat-dialog-close]="true">{{ 'orders.ui.conferma' | transloco }}</button>
    </mat-dialog-actions>
  `,
})
export class DeleteDraftsDialog {
  readonly data = inject<{ count: number }>(MAT_DIALOG_DATA);
}
